import classes from "./Button.module.css";

export const ButtonPrimary = ({ text, type, className, onClick }) => {
  const createRipple = (e) => {
    const button = e.currentTarget;
    const btnRect = button.getBoundingClientRect();

    const circle = document.createElement("span");
    const diameter = Math.max(btnRect.width, btnRect.height);
    const radius = diameter / 2;
    circle.style.width = circle.style.height = `${diameter}px`;
    circle.style.left = `${e.clientX - (btnRect.left + radius)}px`;
    circle.style.top = `${e.clientY - (btnRect.top + radius)}px`;
    circle.classList.add("ripple");

    const ripple = button.getElementsByClassName("ripple")[0];

    if (ripple) {
      ripple.remove();
    }

    if (typeof onClick === "function") {
      onClick();
    }
    button.appendChild(circle);
  };

  return (
    <button
      href="#"
      type={type}
      onClick={createRipple}
      className={`${className} ${classes.buttonPrimary} ${classes.cssRipple}`}
    >
      {text}
    </button>
  );
};

export const ButtonSecondary = ({ text, type, className, onClick }) => {
  return (
    <button
      href="#"
      type={type}
      onClick={onClick}
      className={`${className} ${classes.buttonSecondary}`}
    >
      {text}
    </button>
  );
};
